import { PickerPremium, PickerSubscription } from '../../../lib/plans';

// The active subscription RECORD used for display details (plan name, renew date,
// cancel/switch). This is status-based on purpose: the free-vs-paid DECISION is NOT
// made from this record's shape — see below — so this just finds the user's live
// subscription to read its fields.
export function activePremiumSubscription(premium: PickerPremium | null): PickerSubscription | undefined {
  return (premium?.subscriptions ?? []).find((s) => s.status === 'ACTIVE' || s.status === 'PAST_DUE');
}

// Whether the account is on the free tier, for Settings display.
//
// The authoritative signal is the CREDITS account's `isFreePlan` — the exact field
// the sidebar decides on (components/symphony/sidebar/hooks/use-credits-summary.ts),
// which is now the Symphony BFF's own `plan.kind` (lib/credits-overview.ts). Keying on
// that is what makes Settings and the sidebar agree.
//
// It used to be derived from the legacy Wixel ledger — "the credit grant carries a
// subscriptionId iff paid" — which read a paid SYMPHONY plan as free whenever the account
// held no old Wixel subscription. The fallback below is unchanged and still matters: the
// BFF answer can be absent, and `undefined` must not collapse to "free".
//
// We do NOT decide from `premium.subscriptions`: a real paid plan can be missing a
// Stripe `providerSubscriptionId` AND not be in the current picker catalog (a legacy
// grant), which made both `isPaidActiveSubscription` and a catalog match read it as
// free. When the credits account is unavailable we fall back to "is there an active
// premium record".
export function isFreeSettingsPlan(isFreePlanFromCredits: boolean | undefined, premium: PickerPremium | null): boolean {
  if (isFreePlanFromCredits !== undefined) return isFreePlanFromCredits;
  return !activePremiumSubscription(premium);
}
